import styled from '@emotion/styled';
import { HeaderProfile, SectionText } from '@presentation/components';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';

export const HeaderWrapper = styled.div`
  position: relative;
  margin-bottom: 100px;

  ${mediaQuery('max')} {
    margin-bottom: 80px;
  }

  ${mediaQuery('small')} {
    margin-bottom: 50px;
  }
`;

export const StyledHeaderProfile = styled(HeaderProfile)`
  box-shadow: none;
  padding: 25px 0 !important;
  text-align: center !important;
`;

export const ItemContainer = styled.div`
  margin: 100px 0;

  & > *:not(:last-child) {
    margin-bottom: 50px;
  }
`;

export const ItemWrapper = styled.div<{ orderReversed: boolean }>`
  display: flex;
  /* align-item: center; */
  max-width: 900px;

  ${(props) =>
    props.orderReversed && 'flex-direction: row-reverse; text-align: right; margin-left: auto;'};

  ${mediaQuery('tablet')} {
    align-items: center;
    flex-direction: column;
    text-align: center;
    margin: auto;
  }
`;

export const ItemContentWrapper = styled.div`
  padding: 0 40px;
  ${mediaQuery('tablet')} {
    padding: 0 10px;
  }

  ${mediaQuery('phone')} {
    padding: 0 0px;
  }
`;

export const ItemTitleWrapper = styled.div`
  display: inline-flex;
  align-items: flex-end;
`;

export const ItemTitle = styled.h3`
  ${responsiveFontSize(30, 3)}
  color: ${(props) => props.theme.color.blue.default};
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
`;

export const ItemSubtitle = styled.h4`
  ${responsiveFontSize(20, 0)}
  color: ${(props) => props.theme.color.purple.default};
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  margin-bottom: 10px;
`;

export const ItemText = styled(SectionText)``;

export const ItemImage = styled.img`
  border-radius: 100%;
  width: 200px;
  height: 200px;
  object-fit: cover;
  flex-shrink: 0;

  ${mediaQuery('tablet')} {
    margin-bottom: 20px;
  }
`;

export const SocialsWrapper = styled.div`
  margin-top: 100px;
  padding-bottom: 50px;
`;

export const SocialIconImage = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  margin-left: 10px;
  margin-bottom: 3px;
`;
export const IconWrapper = styled.div`
  width: 28px;
  height: 28px;
  margin-left: 10px;
`;
